export default "__VITE_ASSET__Cf4qhf9v__"